import { formulaCharactersLimit } from '../constant/charactersLimit';

import * as productEndpoints from 'services/product/endpoints';
import sortByKey from 'utils/sortByKey';

import UploadPolyFlourDocumentSupporting from '../components/qa-prod-spec/upload-polyflour-supporting-document';
import { QaSpecHelpContentGridLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';

const mapValue = (value) => {
    if (value === 'null' || value === undefined) {
        return null;
    } else {
        return value;
    }
};

const cellEditorSelectorNumber = (max = 100, min = 0) => {
    return (params) => {
        return {
            component: 'NumericEditor',
            params: {
                max,
                min,
            },
            popup: true,
        };
    };
};

const cellEditorSelectorText = (characterLimitDefine) => {
    return (params) => {
        return {
            component: 'TextEditor',
            popup: true,
            params: {
                maxLength: characterLimitDefine?.[params?.colDef?.field] ?? null,
            },
        };
    };
};

const valueGetterPercent = () => {
    return (params) => {
        const formatValue = params?.data[`${params.colDef?.field}`];
        return formatValue ? formatValue + '%' : '';
    };
};

export const QA_INGREDIENT_FIELDS = [
    'NameofIngredients',
    'IngredientsPartOf',
    'IngredientsFunction',
    'IngredientsOrigin',
    'IngredientsCountryOfOrigin',
    'ReligiousClaim',
    'GMO',
    'Ionized',
    'Allergens',
    'PercentAddedOnProduction',
    'PercentInFinalProduct',
    'Declare',
    'IngredientsDocuments',
    'Total',
    'IngredientStatement',
    'OrganicOrBio',
    'IngredientsProductClaims',
];

export const ORGANIC_BIO_OPTIONS = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
    { label: 'Not Applicable', value: 'Not Applicable' },
];

export const QA_INGREDIENT_COLUMNS = {
    columns: [
        {
            field: 'nameOfIngredients',
            fieldNameCamelCase: 'nameofIngredients',
            displayName: 'Name of Ingredients',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.nameOfIngredients',
            },
        },
        {
            displayName: 'Ingredients Part Of',
            field: 'ingredientsPartOf',
            fieldNameCamelCase: 'ingredientsPartOf',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.ingredientsPartOf',
            },
        },
        {
            displayName: 'Function',
            field: 'function',
            fieldNameCamelCase: 'ingredientsFunction',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: 'qaSpecification.ingredients.ingredientDetails.function',
            },
        },
        {
            displayName: 'Origin',
            field: 'origin',
            fieldNameCamelCase: 'ingredientsOrigin',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: 'qaSpecification.ingredients.ingredientDetails.origin',
            },
        },
        {
            displayName: 'Ingredient Supplier',
            field: 'ingredientSupplier',
            fieldNameCamelCase: 'ingredientSupplier',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.ingredientSupplier',
            },
        },
        {
            displayName: 'Country of Origin',
            field: 'countryOfOrigin',
            fieldNameCamelCase: 'ingredientsCountryOfOrigin',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.countryOfOrigin',
            },
        },
        {
            displayName: 'Religious Claim',
            field: 'religiousClaim',
            fieldNameCamelCase: 'religiousClaim',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.religiousClaim',
            },
        },
        {
            displayName: 'GMO',
            field: 'gmo',
            fieldNameCamelCase: 'GMO',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: 'qaSpecification.ingredients.ingredientDetails.gmo',
            },
        },
        {
            displayName: 'Bioengineered',
            field: 'bioengineered',
            fieldNameCamelCase: 'Bioengineered',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.bioengineered',
            },
        },
        {
            displayName: 'Ionized',
            field: 'ionized',
            fieldNameCamelCase: 'Ionized',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: 'qaSpecification.ingredients.ingredientDetails.ionized',
            },
        },
        {
            displayName: 'Allergens',
            field: 'allergens',
            fieldNameCamelCase: 'Allergens',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: 'qaSpecification.ingredients.ingredientDetails.allergens',
            },
        },
        {
            displayName: '% Added on Production',
            field: 'percentAddedOnProduction',
            fieldNameCamelCase: 'percentAddedOnProduction',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.percentAddedOnProduction',
            },
        },
        {
            displayName: '% in Final Product',
            field: 'percentInFinalProduct',
            fieldNameCamelCase: 'percentInFinalProduct',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath:
                    'qaSpecification.ingredients.ingredientDetails.percentInFinalProduct',
            },
        },
        {
            displayName: 'Document',
            field: 'documents',
            fieldNameCamelCase: 'ingredientDocument',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: TOOlTIP_FIELDS.documentName.fieldPath,
                qaSpecName: 'Ingredients Ingredient Details',
            },
        },
    ],
    gridName: 'qa-spec-ingredient',
};

export const QA_FORMULA_COLUMNS = ({
    productEnums,
    productOwnerId,
    productId,
    options,
}) => {
    let originCodeEnum = [];
    let countryCodeEnum = [];
    productEnums.forEach((enumItem) => {
        if (enumItem?.enumName?.toLowerCase() === 'origincodeenum') {
            originCodeEnum = enumItem?.enumProperties;
        }
        if (enumItem?.enumName?.toLowerCase() === 'countrycodeenum') {
            countryCodeEnum = enumItem?.enumProperties;
        }
    });

    const { useSnapshot } = options || {};

    const cellRenderer = useSnapshot
        ? {
            TextRender: 'TextRenderSnapshot',
            CountryEditorRender: 'CountryEditorRenderSnapshot',
            FileUploadRender: 'FileUploadRenderSnapshot',
        }
        : {
            TextRender: 'TextRender',
            CountryEditorRender: 'CountryEditorRender',
            FileUploadRender: 'FileUploadRender',
        };

    return {
        columns: [
            {
                width: 50,
                maxWidth: 50,
                field: 'error',
                displayName: ' ',
                cellRenderer: 'StatusRender',
                type: 'nonEditableColumn',
            },
            {
                field: 'salesDesignation',
                displayName: 'Common/Label Name',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaSalesDesignation.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'technicalDesignation',
                displayName: 'Technical Designation (IUPAC/INCI)',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaTechnicalDesignation.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'casNumber',
                displayName: 'CAS Number',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaCasNumber.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'country',
                displayName: 'Country',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: (params) => {
                    return {
                        component: 'SelectionEditor',
                        params: {
                            values: sortByKey(countryCodeEnum, 'enumDisplayName').map(
                                (item) => ({
                                    value: item.enumDisplayName,
                                    displayName: item.enumDisplayName,
                                })
                            ),
                            mapValue,
                        },
                        popup: true,
                    };
                },
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaCountry.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'function',
                displayName: 'Function',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaFunction.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'classificationAndRiskPhrases',
                displayName: 'Classification Risk Phrases',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath:
                        TOOlTIP_FIELDS.formulaClassificationAndRiskPhrases.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'origin',
                displayName: 'Origin',
                allowFilter: true,
                allowSort: true,

                valueGetter: function (params) {
                    const value = params.data?.origin;

                    const formatValue = originCodeEnum?.find(
                        (item) => item.enumDisplayName === value
                    )?.enumDisplayName;

                    return formatValue;
                },

                cellEditorSelector: (params) => {
                    return {
                        component: 'SelectionEditor',
                        params: {
                            values: sortByKey(originCodeEnum, 'enumDisplayName').map(
                                (item) => ({
                                    value: item.enumDisplayName,
                                    displayName: item.enumDisplayName,
                                })
                            ),
                            mapValue,
                        },
                        popup: true,
                    };
                },
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaOrigin.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'originSpecification',
                displayName: 'Origin Specification',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorText(formulaCharactersLimit),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaOriginSpecification.fieldPath,
                    qaSpecName: 'Formula',
                },
            },

            {
                field: 'percentOfRawMaterialSubstance',
                displayName: '% (m/m) subtance in the raw material',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorNumber(),
                valueGetter: valueGetterPercent(),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath:
                        TOOlTIP_FIELDS.formulaPercentOfRawMaterialSubstance.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'percentOfIncorporatedRawMaterial',
                displayName:
                    '% (m/m) raw material incorporated in the finished product',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorNumber(),
                valueGetter: valueGetterPercent(),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath:
                        TOOlTIP_FIELDS.formulaPercentOfIncorporatedRawMaterial.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'percentOfFinishedProductSubstance',
                displayName: '% (m/m) subtance in the finished product',
                allowFilter: true,
                allowSort: true,
                cellEditorSelector: cellEditorSelectorNumber(),
                valueGetter: valueGetterPercent(),
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath:
                        TOOlTIP_FIELDS.formulaPercentOfFinishedProductSubstance.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'documents',
                displayName: 'Document',
                allowFilter: true,
                allowSort: true,
                minWidth: 300,
                cellRenderer: cellRenderer['FileUploadRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.formulaDocuments.fieldPath,
                    qaSpecName: 'Formula',
                },
                cellEditorSelector: (params) => {
                    return {
                        component: 'FileUploadEditor',
                        params: {
                            values: originCodeEnum.map((item) => ({
                                value: item.displayName,
                                displayName: item.enumDisplayName,
                            })),
                            apiUrl: productEndpoints.UPLOAD_PIM_ASSET,
                            additionalBodyPayload: async () => {
                                const additionalBodyPayload = {
                                    assetType: 'Document',
                                    assetSubType: 'General',
                                    OwnerId: productOwnerId,
                                    productId,
                                };

                                return additionalBodyPayload;
                            },
                            supportTypes: QA_SPEC_DOCUMENT_FILE_TYPE,
                            confirmDeleteMessage: 'Are you sure you want to delete the file?',
                        },

                        popup: true,
                    };
                },
            },
        ],

        gridName: 'qa-spec-formula',
    };
};

export const QA_FORMULA_ACTIVE_INGREDIENT_COLUMNS = (options) => {
    const { useSnapshot } = options;
    const cellRenderer = useSnapshot
        ? {
            TextRender: 'TextRenderSnapshot',
            CountryEditorRender: 'CountryEditorRenderSnapshot',
        }
        : {
            TextRender: 'TextRender',
            CountryEditorRender: 'CountryEditorRender',
        };

    return {
        columns: [
            {
                field: 'error',
                displayName: ' ',
                maxWidth: 50,
                cellRenderer: 'StatusRender',
                editable: false,
                allowFilter: false,
                allowSort: false,
            },
            {
                field: 'ingredientName',
                displayName: 'Ingredient Name',
                allowFilter: true,
                allowSort: true,
                flex: 1,
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.activeIngredientName.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'purposeDescriptor',
                displayName: 'Purpose',
                allowFilter: true,
                allowSort: true,
                cellRenderer: cellRenderer['TextRender'],
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.activeIngredientPurposeDescriptor.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'quantity',
                displayName: 'Quantity',
                allowFilter: true,
                allowSort: true,
                maxWidth: 160,
                minWidth: 160,
                cellRenderer: cellRenderer['TextRender'],
                cellEditorSelector: (params) => {
                    return {
                        component: 'NumericEditor',
                    };
                },
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.activeIngredientQuantity.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
            {
                field: 'quantityUom',
                displayName: 'UOM',
                allowFilter: true,
                allowSort: true,
                maxWidth: 120,
                minWidth: 120,
                cellRenderer: cellRenderer['TextRender'],
                cellEditorSelector: (params) => {
                    return {
                        component: 'SelectionEditor',
                        params: {
                            values: [
                                {
                                    value: 'g',
                                    displayName: 'g',
                                },
                                {
                                    value: 'mg',
                                    displayName: 'mg',
                                },
                                {
                                    value: 'mcg',
                                    displayName: 'mcg',
                                },
                            ],
                        },
                    };
                },
                headerComponent: QaSpecHelpContentGridLabel,
                headerComponentParams: {
                    fieldPath: TOOlTIP_FIELDS.activeIngredientQuantityUom.fieldPath,
                    qaSpecName: 'Formula',
                },
            },
        ],
    };
};

export const QA_ALLERGENS_COLUMNS = {
    columns: [
        {
            field: 'allergenType',
            displayName: 'Allergen',
            allowFilter: true,
            allowSort: true,
            editable: false,
            maxWidth: 250,
            headerComponentParams: {
                fieldPath: TOOlTIP_FIELDS.allergenTypeCode.fieldPath,
            },
        },
        {
            field: 'isPresent',
            displayName: 'Is Present',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: TOOlTIP_FIELDS.allergenIsPresent.fieldPath,
            },
        },
        {
            field: 'levelOfContainment',
            displayName: 'Level of Containment',
            allowFilter: true,
            allowSort: true,
            headerComponentParams: {
                fieldPath: TOOlTIP_FIELDS.levelOfContainmentCode.fieldPath,
            },
        },
        {
            field: 'containmentSource',
            displayName: 'Containment Source',
            allowFilter: true,
            allowSort: true,
            maxWidth: 400,
            minWidth: 300,
            headerComponentParams: {
                fieldPath: TOOlTIP_FIELDS.containmentSource.fieldPath,
            },
        },
    ],
    gridName: 'qa-spec-allergen',
};

export const QA_SPEC_STYLE_CONST = {
    HEADER_OFFSET: 10,
    PRODUCT_HEADER_IMAGE_WRAPPER_PADDING: 7,
    TAB_HEADER_DISTANCE_TO_ICON: 25,
};

export const CATEGORY_LABEL = {
    category1: 'Category I',
    category2: 'Category II',
    category3: 'Category III',
    category4: 'Category IV',
};

export const skuPropertiesList = () => [
    {
        id: 1,
        label: 'qaSpecType',
        value: 'type',
        inputType: 'selectType',
        fieldPath: 'qaSpecification.type',
    },
    {
        id: 2,
        label: 'qaSpecNationalBrandTarget',
        value: 'nationalBrandTarget',
        inputType: 'input',
        fieldPath: 'qaSpecification.competitiveProduct',
    },
    {
        id: 3,
        label: 'qaSpecSKUType',
        value: 'skuType',
        inputType: 'input',
        fieldPath: 'qaSpecification.skuType',
    },
    {
        id: 4,
        label: 'qaSpecNationalBrandTargetUpc',
        value: 'nationalBrandTargetUpc',
        inputType: 'input',
        fieldPath: 'qaSpecification.competitiveProductUpc',
    },
    {
        id: 5,
        label: 'qaCompetitiveProductBrandRetailPricingTarget',
        value: 'competitiveProductBrandRetailPricingTarget',
        inputType: 'inputRetailPricingTarget',
        fieldPath: 'qaSpecification.competitiveBrandEquivalencyType',
    },
    {
        id: 6,
        label: 'qaSpecCompetitiveBrandEquivalencyType',
        value: 'competitiveBrandEquivalencyType',
        inputType: 'selectCompetitiveBrand',
        fieldPath: 'qaSpecification.competitiveBrandEquivalencyType',
    },
    {
        id: 7,
        label: 'qaSpecDifferencesAccepted',
        value: 'differencesAccepted',
        inputType: 'inputDifferencesAccepted',
        fieldPath: 'qaSpecification.differencesAccepted',
    },
    {
        id: 8,
        label: 'qaSpecSupplierLocation',
        value: 'supplierLocation',
        inputType: 'countrySelect',
        fieldPath: 'qaSpecification.supplierLocation',
    },
    {
        id: 9,
        label: 'qaSpecTestingTier',
        value: 'testingTier',
        inputType: 'selectTestingTier',
        fieldPath: 'qaSpecification.testingTier',
    },
    {
        id: 10,
        label: 'qaSpecRetailBanner',
        value: 'retailer',
        inputType: 'input',
        fieldPath: 'qaSpecification.retailBanner',
    },
    {
        id: 11,
        label: 'qaSpecSmartLabelTemplate',
        value: 'smartLabelTemplate',
        inputType: 'selectSmartLabel',
        fieldPath: 'qaSpecification.smartLabelTemplate',
    },
    {
        id: 12,
        label: 'qaSpecCategory1',
        value: 'category1',
        inputType: 'disableInput',
        fieldPath: 'qaSpecification.cat1Name',
    },
    {
        id: 13,
        label: 'qaSpecCategory2',
        value: 'category2',
        inputType: 'disableInput',
        fieldPath: 'qaSpecification.cat2Name',
    },
    {
        id: 14,
        label: 'qaSpecCategory3',
        value: 'category3',
        inputType: 'disableInput',
        fieldPath: 'qaSpecification.cat3Name',
    },
    {
        id: 15,
        label: 'qaSpecCategory4',
        value: 'category4',
        inputType: 'disableInput',
        fieldPath: 'qaSpecification.cat4Name',
    },
];

export const CATEGORY_PRODUCT_LIST = [
    {
        id: 'category1',
        label: 'Category I',
        value: 'category1Id',
        inputType: 'disableInput',
    },
    {
        id: 'category2',
        label: 'Category II',
        value: 'category2Id',
        inputType: 'disableInput',
    },
    {
        id: 'category3',
        label: 'Category III',
        value: 'category3Id',
        inputType: 'disableInput',
    },
    {
        id: 'category4',
        label: 'Category IV',
        value: 'category4Id',
        inputType: 'disableInput',
    },
];

export const defaultType = 'N/A';

export const QA_SPEC_CONTACT = {
    primaryBusiness: {
        key: 'primaryBusiness',
        fields: [
            {
                name: 'name',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryBusinessContact.name',
            },
            {
                name: 'addressLine1',
                type: 'text',
                fieldPath:
                    'qaSpecification.contacts.primaryBusinessContact.addressLine1',
            },
            {
                name: 'addressLine2',
                type: 'text',
                fieldPath:
                    'qaSpecification.contacts.primaryBusinessContact.addressLine2',
            },
            {
                name: 'country',
                type: 'country',
                fieldPath: 'qaSpecification.contacts.primaryBusinessContact.country',
            },
            {
                name: 'phone',
                type: 'phone',
                fieldPath: 'qaSpecification.contacts.primaryBusinessContact.phone',
            },
            {
                name: 'email',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryBusinessContact.email',
                rules: [{ type: 'email', message: 'Invalid Email' }],
            },
        ],
    },

    primaryQc: {
        key: 'primaryQc',
        fields: [
            {
                name: 'name',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.name',
            },
            {
                name: 'addressLine1',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.addressLine1',
            },
            {
                name: 'addressLine2',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.addressLine2',
            },
            {
                name: 'country',
                type: 'country',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.country',
            },
            {
                name: 'phone',
                type: 'phone',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.phone',
            },
            {
                name: 'email',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.primaryQcContact.email',
                rules: [{ type: 'email', message: 'Invalid Email' }],
            },
        ],
    },

    _24Hour: {
        key: '_24Hour',
        fields: [
            {
                name: 'name',
                type: 'text',
                fieldPath: 'qaSpecification.contacts._24HourContact.name',
            },
            {
                name: 'addressLine1',
                type: 'text',
                fieldPath: 'qaSpecification.contacts._24HourContact.addressLine1',
            },
            {
                name: 'addressLine2',
                type: 'text',
                fieldPath: 'qaSpecification.contacts._24HourContact.addressLine2',
            },
            {
                name: 'country',
                type: 'country',
                fieldPath: 'qaSpecification.contacts._24HourContact.country',
            },
            {
                name: 'phone',
                type: 'phone',
                fieldPath: 'qaSpecification.contacts._24HourContact.phone',
            },
            {
                name: 'email',
                type: 'text',
                fieldPath: 'qaSpecification.contacts._24HourContact.email',
                rules: [{ type: 'email', message: 'Invalid Email' }],
            },
        ],
    },

    packaging: {
        key: 'packaging',
        fields: [
            {
                name: 'name',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.packagingContact.name',
            },
            {
                name: 'addressLine1',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.packagingContact.addressLine1',
            },
            {
                name: 'addressLine2',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.packagingContact.addressLine2',
            },
            {
                name: 'country',
                type: 'country',
                fieldPath: 'qaSpecification.contacts.packagingContact.country',
            },
            {
                name: 'phone',
                type: 'phone',
                fieldPath: 'qaSpecification.contacts.packagingContact.phone',
            },
            {
                name: 'email',
                type: 'text',
                fieldPath: 'qaSpecification.contacts.packagingContact.email',
                rules: [{ type: 'email', message: 'Invalid Email' }],
            },
        ],
    },

  plantManager: {
    key: 'plantManager',
    fields: [
      {
        name: 'facilityName',
        type: 'text',
        fieldPath: 'qaSpecification.contacts.plantManager.name',
      },
      {
        name: 'facilityAddressLine1',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.addressLine1',
      },
      {
        name: 'facilityAddressLine2',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.addressLine2',
      },
      {
        name: 'country',
        type: 'country',
        fieldPath: 'qaSpecification.contacts.plantManager.country',
      },
      {
        name: 'faxNumber',
        type: 'text',
        fieldPath: 'qaSpecification.contacts.plantManager.faxNumber',
      },
      {
        name: 'facilityPlantManagerEmail',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityPlantManagerEmail',
        rules: [{ type: 'email', message: 'Invalid Email' }],
      },
      {
        name: 'facilityPlantManagerName',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityPlantManagerName',
      },
      {
        name: 'facilityPlantManagerPhone',
        type: 'phone',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityPlantManagerPhone',
      },
      {
        name: 'facilityQaEmail',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityQaEmail',
        rules: [{ type: 'email', message: 'Invalid Email' }],
      },
      {
        name: 'facilityQaName',
        type: 'text',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityQaName',
      },
      {
        name: 'facilityQaPhone',
        type: 'phone',
        fieldPath:
          'qaSpecification.contacts.plantManager.facilityQaPhone',
      },
    ],
  },

};
export const titleQAContactSection = {
  primaryBusiness: 'Primary Business Contact',
  primaryQc: 'Primary QA contact',
  _24Hour: '24 Hour Contact',
  packaging: 'Packaging Contact',
  plantManager: ' Plant Manager',
  
};

export const INGREDIENT_LIST_ERRORS = {
    INGREDIENT_NAME_EXISTED: 'Ingredient name existed',
    INGREDIENT_NAME_EMPTY: 'Ingredient name cannot be empty',
};

export const ALLERGEN_LIST_ERRORS = {
    LEVEL_OF_CONTAINMENT_EMPTY: 'Level of containment cannot be empty',
    CONTAINMENT_SOURCE_EMPTY: 'Containment source cannot be empty',
};

export const PHYSICAL_AND_CHEMICAL_CHARACTERISTICS_ERRORS = {
    AT_LEAST_ONE_ENTRY: 'At least one field value is required',
};

export const CONTAINMENT_CHARACTERISTICS_ERRORS = {
    AT_LEAST_ONE_ENTRY: 'At least one field value is required',
};

export const MICROBIOLOGICAL_CHARACTERISTICS_ERRORS = {
    AT_LEAST_ONE_ENTRY: 'At least one field value is required',
};

export const ORGANOLEPTIC_CHARACTERISTICS_ERRORS = {
    SPECIFICATION: 'Specification/Description/Target is required',
    TOLERANCE: 'Tolerance is required',
    FREQUENCY: 'Frequency is required',
    RELEASE: 'Release Criteria is required',
    PREPARATION_METHOD: 'Preparation Method is required',
    REJECT: 'Reject/Fail Criteria is required',
};

export const MICROBIOLOGICAL_PARAMETER_OPTIONS = [
    { value: 'APC', displayName: 'APC' },
    { value: 'Campylobacter', displayName: 'Campylobacter' },
    { value: 'Coliforms', displayName: 'Coliforms' },
    { value: 'E. coli', displayName: 'E. coli' },
    {
        value: 'Listeria Monocytogenes',
        displayName: 'Listeria Monocytogenes',
    },
    { value: 'Mold', displayName: 'Mold' },
    { value: 'Other', displayName: 'Other' },
    { value: 'Salmonella', displayName: 'Salmonella' },
    { value: 'Shigella', displayName: 'Shigella' },
    { value: 'Yeast', displayName: 'Yeast' },
    {
        value: 'Staphylococcus Aureus',
        displayName: 'Staphylococcus Aureus',
    },
];

export const TYPE = ['HBC', 'Non-Food', 'Food'];
export const customWidthFormulaColumns = {
    Country: 300,
    documents: 300,
    technicalDesignation: 295,
    classificationAndRiskPhrases: 225,
    percentOfRawMaterialSubstance: 300,
    percentOfIncorporatedRawMaterial: 420,
    percentOfFinishedProductSubstance: 350,
};

export const QA_SPEC_DOCUMENT_FILE_TYPE = [
    'jpeg',
    'png',
    'jpg',
    'tiff',
    'tif',
    'mp4',
    'mov',
    'avi',
    'mp3',
    'zip',
    'rar',
    'txt',
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'bmp',
    'gif',
    'webm',
    'csv',
];

export const documentTypes = ['ppt', 'pptx', 'doc', 'docx', 'pdf'];

export const PRODUCT_SPEC_FORM_SECTION_SCHEMA = {
    DATE_CODING: {
        key: 'productSpecDateCoding',
        fields: [
            {
                name: 'codeDateStamp',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.codeDateStamp',
            },
            {
                name: 'codeDateType',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.codeDateType',
            },
            {
                name: 'codeDateFormula',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.codeDateFormula',
            },
            {
                name: 'codeDateExample',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.codeDateExample',
            },
            {
                name: 'batchCodeExample',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.batchCodeExample',
            },
            {
                name: 'lotCodeExample',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.lotCodeExample',
            },
        ],
    },

    CASE_TEMPERATURE: {
        key: 'productSpecCaseTemperature',
        fields: [
            {
                name: 'caseTemperatureRangeHigh',
                type: 'number',
                fieldPath:
                    'qaSpecification.productSpecification.caseTemperatureRangeHigh',
            },
            {
                name: 'caseTemperatureRangeLow',
                type: 'number',
                fieldPath:
                    'qaSpecification.productSpecification.caseTemperatureRangeLow',
            },
            {
                name: 'caseShippingTemperatureHigh',
                type: 'number',
                fieldPath:
                    'qaSpecification.productSpecification.caseShippingTemperatureHigh',
            },
            {
                name: 'caseShippingTemperatureLow',
                type: 'number',
                fieldPath:
                    'qaSpecification.productSpecification.caseShippingTemperatureLow',
            },
        ],
    },

  POLYFLUOROALKYL_SUBSTANCES: {
    key: 'polyfluoroalkylSubstances',
    fields: [
      {
        name: 'productContainPfas',
        type: 'checkbox',
        options: (enumOptions) =>
          enumOptions?.polyflour?.['productContainPfas'].map((option) => ({
            label: option.label,
            value: option.value,
          })),
        formItemProps: {
          labelCol: { span: 24 },
          wrapperCol: {
            span: 24,
          },
        },
        fieldPath: 'qaSpecification.claimsDetails.pfas.productContainPfas',
      },
      {
        name: 'productPackagingContainPfas',
        type: 'checkbox',
        options: (enumOptions) =>
          enumOptions?.polyflour?.['productPackagingContainPfas'].map(
            (option) => ({
              label: option.label,
              value: option.value,
            })
          ),
        formItemProps: {
          labelCol: { span: 24 },
          wrapperCol: {
            span: 24,
          },
        },
        fieldPath:
          'qaSpecification.claimsDetails.pfas.productPackagingContainPfas',
      },
      {
        name: 'conductedAnyPFSTesting',
        type: 'checkbox',
        options: (enumOptions) =>
          enumOptions?.polyflour?.['conductedAnyPFSTesting'].map((option) => ({
            label: option.label,
            value: option.value,
          })),
        formItemProps: {
          labelCol: { span: 24 },
          wrapperCol: {
            span: 24,
          },
        },
        fieldPath:
          'qaSpecification.claimsDetails.pfas.conductedAnyPFSTesting',
      },
      {
        name: 'conductedAnyPFASTestingProductPackaging',
        type: 'checkbox',
        options: (enumOptions) =>
          enumOptions?.polyflour?.[
            'conductedAnyPFASTestingProductPackaging'
          ].map((option) => ({
            label: option.label,
            value: option.value,
          })),
        formItemProps: {
          labelCol: { span: 24 },
          wrapperCol: {
            span: 24,
          },
        },
        fieldPath:
          'qaSpecification.claimsDetails.pfas.conductedAnyPFASTestingProductPackaging',
      },
      {
        name: 'pfasStatement',
        type: 'textarea',
        inputProps: {
          showCount: true,
          maxLength: 500,
          rows: 4,
        },
        formItemProps: {
          labelCol: { span: 24 },
          wrapperCol: {
            span: 24,
          },
        },
        fieldPath: 'qaSpecification.claimsDetails.pfas.pfasStatement',
      },
      {
        name: 'supportingDocumentation',
        fieldPath: 'qaSpecification.claimsDetails.pfas.supportingDocument',
        inputRender: ({ isEdit }) => (
          <UploadPolyFlourDocumentSupporting isEdit={isEdit} />
        ),
        formItemProps: {
          labelCol: { flex: '175px' },
          wrapperCol: {
            flex: 'auto',
          },
        },
      },
    ],
  },

    SHELF_LIFE: {
        key: 'productSpecShelfLife',
        fields: [
            {
                name: 'minimumShelfLife',
                type: 'number',
                fieldPath: 'qaSpecification.productSpecification.minimumShelfLife',
            },
            {
                name: 'maximumShelfLife',
                type: 'number',
                fieldPath: 'qaSpecification.productSpecification.maximumShelfLife',
            },
            {
                name: 'shelfLifeAfterOpening',
                type: 'text',
                fieldPath: 'qaSpecification.productSpecification.shelfLifeAfterOpening',
            },
        ],
    },

  DIETARY: {
    key: 'productSpecDietaryCertifications',
    fields: [
      {
        name: 'kosherYN',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.kosherYN',
      },
      {
        name: 'kosherCertifier',
        isList: true,
        type: 'select',
        enum: 'KosherCertificationEnum',
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.kosherCertifier',
      },
      {
        name: 'organicYN',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.organicYN',
      },
      {
        name: 'organicCertifier',
        type: 'text',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.organicCertifier',
      },
      {
        name: 'halalYN',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.halalYN',
      },
      {
        name: 'halalCertifier',
        type: 'select',
        enum: 'HalalCertifierEnum',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.halalCertifier',
      },
      {
        name: 'nonGMOYN',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.nonGMOYN',
      },
      {
        name: 'nonGMOCertifier',
        type: 'select',
        enum: 'NonGMOCertifierEnum',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.nonGMOCertifier',
      },
      {
        name: 'isoyn',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.isoyn',
      },
      {
        name: 'isoCertifier',
        type: 'text',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.isoCertifier',
      },
      {
        name: 'brcyn',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.brcyn',
      },
      {
        name: 'brcCertifier',
        type: 'text',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.brcCertifier',
      },
      {
        name: 'ifsyn',
        type: 'checkbox',
        col: 9,
        haveUploadCertificate: true,
        fieldPath: 'qaSpecification.productSpecification.ifsyn',
      },
      {
        name: 'ifsCertifier',
        type: 'text',
        isList: true,
        col: 15,
        layout: { labelCol: { span: 8 }, wrapperCol: { span: 16 } },
        fieldPath: 'qaSpecification.productSpecification.ifsCertifier',
      },
    ],
  },
  DIETARY_WITHOUT_CERTIFICATION: {
    key: 'productSpecDietaryWithoutCertifications',
    fields: [
      // {
      //   name: 'kosherYN',
      //   type: 'checkbox',
      //   col: 24,
      //   haveUploadCertificate: false,
      //   fieldPath: 'qaSpecification.productSpecification.kosherYN',
      // },
      // {
      //   name: 'organicYN',
      //   type: 'checkbox',
      //   col: 24,
      //   haveUploadCertificate: false,
      //   fieldPath: 'qaSpecification.productSpecification.organicYN',
      // },
      // {
      //   name: 'halalYN',
      //   type: 'checkbox',
      //   col: 24,
      //   haveUploadCertificate: false,
      //   fieldPath: 'qaSpecification.productSpecification.halalYN',
      // },      
      // {
      //   name: 'nonGMOYN',
      //   type: 'checkbox',
      //   col: 24,
      //   haveUploadCertificate: false,
      //   fieldPath: 'qaSpecification.productSpecification.nonGMOYN',
      // },
      {
        name: 'isoyn',
        type: 'checkbox',
        col: 24,
        haveUploadCertificate: false,
        fieldPath: 'qaSpecification.productSpecification.isoyn',
      },
      {
        name: 'brcyn',
        type: 'checkbox',
        col: 24,
        haveUploadCertificate: false,
        fieldPath: 'qaSpecification.productSpecification.brcyn',
      },
      {
        name: 'ifsyn',
        type: 'checkbox',
        col: 24,
        haveUploadCertificate: false,
        fieldPath: 'qaSpecification.productSpecification.ifsyn',
      },
    ],
  },
  STATEMENT: {
    key: 'productSpecStatement',
    fields: [
      {
        name: 'gmoStatement',
        type: 'text',
        fieldPath: 'qaSpecification.productSpecification.gmoStatement',
      },
      {
        name: 'nonGmoStatement',
        type: 'text',
        fieldPath: 'qaSpecification.productSpecification.nonGmoStatement',
      },
      {
        name: 'productContainsBioengineeredIngredients',
        type: 'productContainsBioengineeredIngredients',
        option: 'productContainsBioengineeredIngredients',
        fieldPath:
          'qaSpecification.productSpecification.productContainsBioengineeredIngredients',
      },
      {
        name: 'bioengineeredStatement',
        type: 'text',
        fieldPath:
          'qaSpecification.productSpecification.bioengineeredStatement',
      },
      // {
      //   name: 'nonfoodIngredientStatement',
      //   type: 'text',
      // },
      {
        name: 'rbghBstStatement',
        type: 'text',
        fieldPath: 'qaSpecification.productSpecification.rbghBstStatement',
      },
      {
        name: 'californiaProp65WarningStatement',
        type: 'text',
        fieldPath:
          'qaSpecification.productSpecification.californiaProp65WarningStatement',
      },
      {
        name: 'fairTradeStatement',
        type: 'text',
        fieldPath: 'qaSpecification.productSpecification.fairTradeStatement',
      },
      {
        name: 'usdaStatement',
        type: 'text',
        fieldPath: 'qaSpecification.productSpecification.usdaStatement',
      },
    ],
  },

  LOCATION: {
    key: 'productSpecLocation',
    fields: [
      {
        name: 'targetMarket',
        type: 'targetMarket',
        option: 'targetMarket',
        fieldPath: 'qaSpecification.productSpecification.targetMarket',
      },
    ],
  },
};

export const ALLERGEN_CONTAINMENT_SOURCE_OPTIONS = [
    {
        value: 'Manufactured on shared equipment',
        displayName: 'Manufactured on shared equipment',
    },
    {
        value: 'Manufactured in the same facility',
        displayName: 'Manufactured in the same facility',
    },
];

export const PRODUCT_SPEC_DIETARY_CERTIFICATION_FIELDS = {
    kosherYN: 'kosherCertifier',
    organicYN: 'organicCertifier',
    halalYN: 'halalCertifier',
    nonGMOYN: 'nonGMOCertifier',
    isoyn: 'isoCertifier',
    brcyn: 'brcCertifier',
    ifsyn: 'ifsCertifier',
};

export const PRODUCT_SPEC_DIETARY_CERTIFICATION_MAP_FIELD_SCHEMA_TO_CERTIFICATE_TYPE =
{
    kosherCertifier: 'Kosher',
    organicCertifier: 'Organic',
    halalCertifier: 'Halal',
    nonGMOCertifier: 'Non GMO',
    isoCertifier: 'ISO',
    brcCertifier: 'BRC',
    ifsCertifier: 'IFS',
};

export const MINIMUM_INPUT_FIELD = ['productSpecShelfLife'];

const INGREDIENT_STATEMENT_LIMIT_CHARACTERS = 2000;

export const INGREDIENT_LIMIT_CHARACTERS = {
    nameOfIngredients: 250,
    function: 5000,
    percentAddedOnProduction: 5000,
    percentInFinalProduct: Math.pow(10, 50) - 1,
    ingredientStatement: INGREDIENT_STATEMENT_LIMIT_CHARACTERS,
    ingredientClaims: 500,
};

export const FRESH_MEAT_LIMIT_CHARACTERS = {
    typeOfCutOrTrimSpec: 500,
};

export const FRESH_SEAFOOD_LIMIT_CHARACTERS = {
    typeOfCutOrTrimSpec: 500,
    methodOfProduction: 500,
    methodOfCapture: 500,
    productionSystem: 500,
    seafoodRiskCategory: 500,
    safeHandlingInstructions: 500,
};

export const PACKAGING_LIMIT_CHARACTERS = {
    ingredientStatement: INGREDIENT_STATEMENT_LIMIT_CHARACTERS,
    allergenStatement: 500,
    storageInstructions: 500,
    handlingInstructions: 500,
    romanceCopy: 500,
    usage: 500,
    cookingInstructions: 2000,
    recipe: 500,
    bioengineeredStatement: 500,
    warningStatement: 3000,
    otherCertifications: 500,
    thawingInstructions: 500,
};

export const PACKAGING_LIMIT_CHARACTERS_HBC_OTC_TYPE = {
    warningStatement: 3000,
    cookingInstructions: 2000,
};

export const ALLERGEN_LIMIT_CHARACTERS = {
    allergenStatement: 1200,
};

export const PRODUCT_SPEC_LIMIT_CHARACTERS = {
    document: {
        characteristicsType: 100,
    },
};

export const DOCUMENT_CERTIFICATE_LIMIT_CHARACTER = {
    documentType: 50,
    certificateBody: 50,
};

export const COMPONENTS_ERROR = {
    EXISTED: 'Component existed',
    EMPTY: 'Component cannot be empty',
};

export const DAIRY_LIMIT_CHARACTERS = {
    liveActiveCultures: 500,
    complianceStatement: 500,
    referralStatements: 500,
    eggsGrading: 500,
    relativeComparativeClaims: 500,
    healthClaims: 500,
    structureFunctionClaims: 500,
};

export const DAIRY_SECTION_TEXT_AREA = [
  {
    displayName: 'Quality Guarantee',
    fieldName: 'qualityGuarantee',
    limitCharacters: 500,
    fieldPath: 'qaSpecification.productSpecification.qualityGuarantee',
  },
  {
    displayName: 'Compliance Statement',
    fieldName: 'complianceStatement',
    limitCharacters: 500,
    fieldPath: 'qaSpecification.productSpecification.complianceStatement',
  },
  // {
  //   displayName: 'Health Claims',
  //   fieldName: 'healthClaims',
  //   limitCharacters: 500,
  //   fieldPath: 'qaSpecification.productSpecification.healthClaims',
  // },
];

//* ticket #6159 - separate DAIRY_SECTION_TEXT_AREA to DAIRY_SECTION_TEXT_AREA_2 in order to put Gluten Free Claim between
export const DAIRY_SECTION_TEXT_AREA_2 = [
    {
        displayName: 'Structure / Function Claims',
        fieldName: 'structureFunctionClaims',
        limitCharacters: 500,
        fieldPath: 'qaSpecification.productSpecification.structureFunctionClaims',
    },
    {
        displayName: 'Relative / Comparative Claims',
        fieldName: 'relativeComparativeClaims',
        limitCharacters: 500,
        fieldPath: 'qaSpecification.productSpecification.relativeComparativeClaims',
    },
    {
        displayName: 'Safe Handling Instructions',
        fieldName: 'safeHandlingInstructions',
        limitCharacters: 500,
        fieldPath: 'qaSpecification.productSpecification.safeHandlingInstructions',
    },
    {
        displayName: 'Live and Active Culture',
        fieldName: 'liveActiveCultures',
        limitCharacters: 500,
        fieldPath: 'qaSpecification.productSpecification.liveActiveCultures',
    },
];

export const MEAT_FISH_SECTION_TEXT_AREA = [
    {
        displayName: 'Safe Handling Instructions',
        fieldName: 'safeHandlingInstructions',
        limitCharacters: 500,
    },
    {
        displayName: 'Quality Guarantee',
        fieldName: 'qualityGuarantee',
        limitCharacters: 500,
    },
    {
        displayName: 'Thawing Instructions',
        fieldName: 'thawingInstructions',
        limitCharacters: 500,
    },
];

export const CONTAINER_EXPANDED_WIDTH = 1300;
export const CONTAINER_COLLAPSED_WIDTH = 1202;
export const NAV_WIDTH = 240;
